import { React, useEffect } from "react";

import Board from "./Board";
import DetermineComputerMove from "./DetermineComputerMove";
import JumpToStep from '../GameFunctions/JumpToStep';
import ProcessMove from '../GameFunctions/ProcessMove';
import { boardFull, CalculateWinner, Pause } from '../GameFunctions/MiscGameFunctions';
/***********************************************************************************************************
 *  The Game component is the top-level parent component.
 */
function Game({ onePlayerGame, history, setHistory, skillLevel, stepNumber, setStepNumber, xIsNext, setXIsNext }) {
  // uses the Board module to render the entire game board

  useEffect(() => {
  }, [history]);
 
  let winningElements = [];
  let singlePlayerInstruction = <span></span>;
  let status = "";

  let newHistoryFromProcessMove;
  const handleClick = (squareNumber) => {  // The squareNumber is the square number that is clicked
    ProcessMove(
      squareNumber, 
      history, 
      setHistory,
      stepNumber, 
      setStepNumber, 
      xIsNext, 
      setXIsNext);
    let newHistory = structuredClone(newHistoryFromProcessMove);
    Pause();
  
  };

  const handleComputerMove = (squareNumber) => {
    ProcessMove(
      squareNumber, 
      history, 
      setHistory,
      stepNumber, 
      setStepNumber,
      xIsNext, 
      setXIsNext);
  };

  const moves = history.map((step, move) => {      // step is current element value & map is current move index
    const descript = move ?                        // description for each move such as "Go to move #5"
      'Go to move #' + move :
      'Go to game start';
    return (
      <li key={move}>
        <button onClick={() => JumpToStep(
          move,
          setStepNumber,
          setXIsNext
          )}>{descript}</button>
      </li>                                          // When a description is clicked, jump to that move in the game history
    );
  });

  /* When the game is in play, the squares array will look like this:
    [
      'O', null, 'X',
      'X', 'X', 'O',
      'O', null, null,
    ]
  */
    
    let current = history[stepNumber];
    let squares = current.squares;
    winningElements = CalculateWinner(squares); // send an array of all current squares to see if we have a winner;
    let winner = "";
    let winningNumbers = "";
    if (winningElements && winningElements.length) {
      winner = squares[winningElements[winningElements.length - 1]]; // if at least one element get the value (X/O)
      for (const number of winningElements) {
        winningNumbers += number + " ";
      }
    };
    
    if (winner) {
      if (onePlayerGame) {
        status = (winner === 'X'? `Congratulations, you won against the computer (${skillLevel} level)!` : 'The computer won, better luck next time.');
      } else {
        status = (winner === 'X'? 'Player X has won the game!' : 'Player O has won the game!');
      }
    } else {
      if (stepNumber === 9) {
        status = 'It is a tied game';
      } else {
        status = 'Next player is: ' + (xIsNext ? 'X' : 'O');
      }
    };

    /*  At this point if we are in one-player mode and the next player is "O" we need to determine the proper move and then
        call the handleClick routine to trigger the new move logic. In this case we are not expecting the move to come from
        the board component.  
    */

    if (onePlayerGame && !stepNumber) {
      singlePlayerInstruction = <span className='instruction'> You are playing against the computer - you go first - Skill Level: {skillLevel} </span>;
    };

    if (onePlayerGame && !xIsNext && (stepNumber < 8)) {
      const computerMove = DetermineComputerMove(squares, skillLevel);
      handleComputerMove(computerMove);
    };

    return (
      <div className="game">
        {singlePlayerInstruction}
        <br /> <br />
        <div className="game-board">
          <Board
            squares={squares}
            onClick={squareNumber => handleClick(squareNumber)}
            winningElements={winningElements} // Send list of winning elements to the Board module
          />
        </div>
        <div className="game-info">
          <div>{status}</div>
          <h6 className="instruction"> In the area below you can click on any step in the game to restart the game from that point. It is like an unlimited undo. </h6>
          <ol>{moves}</ol>
        </div>
      </div>
    );
};

export default Game;